import React, { useContext } from 'react'
import { CommonStyle } from '../styles/common-styles';
import bannerImage from '../public/images/top-view-downtown.png';
import UseWindowSize from '../hooks/helpers/useWindowSize';
import Link from 'next/link';
import Head from 'next/head';
import { DownloadAppFooter } from '../components/download-app-footer';
import { JobContext } from '../contexts/JobContext';
import GoogleMapReact from 'google-map-react'
import GarageMap from '../components/google-map/google-map';
import Image from 'next/image';

function SupportedLocation() {
    const { windowSize } = UseWindowSize();
    const {garages, serviceZipCodes} = useContext(JobContext);

    return (
        <div className="container-fluid p-0">
            <Head>
                <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
                <meta name="author" content="Paleo Car Care" />
                <meta property="og:title" content="Paleo Car Care - Check if We Serve Your Area: Supported Zip Codes for Exceptional Auto Services" />
                <meta property="og:image" itemProp="image" content="/images/referral-banner.png" />
                <meta name="facebook-domain-verification" content="m4o6pn81efn34qkf6t3fimmjnhbuxs" />
                <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="alternate" href="https://www.paleocarcare.com/supportedzipcodes.html" hrefLang="en" />
            </Head>
            <CommonStyle>
                <div className="bg-light-white py-3 px-0" >
                    <div className="container" style={{ minHeight: 400, height: 400 }}>
                        <div className="d-md-flex  mt-5 pb-5">
                            <div className="caption col-md-7 col-lg-6 d-flex flex-column mt-0 mt-lg-5 ">
                                <div className=" col-md-10 mt-lg-5  d-flex  jusify-content-center align-items-center">
                                    <h1 className="heavy-bold dark-text mx-md-auto" style={windowSize?.width >= 920 ? { fontSize: '2.8rem' } : {}} >
                                        San Antonio’s<br />
                                        Best Kept Secret <br />
                                        <span className='text-danger'> For Now.</span>
                                    </h1>

                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6 my-4 my-lg-0 text-center position-relative">
                                <div className='position-absolute' >
                                    <Image
                                    src={bannerImage.src}
                                    alt="top-banner"
                                    className="img-fluid rounded"
                                    width="650vh" 
                                    height="430vh"
                                    loading="lazy"
                                    // layout='responsive'
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='bg-white py-md-5'>
                        <div className='container caption mt-lg-5 py-5 col-md-8 text-center '>
                            <h2 className='heavy-bold py-lg-5 fs-1'>
                                We Just Launched. And We’re Growing.<span className='text-danger'> Quick.</span>
                            </h2>
                            <h3 className='grey-text text-md-left mt-5'>
                                Paleo Car Care launched in Spring 2021 in just three zip codes within the urban core of San Antonio. We’re expanding rapidly, so check back often to find out if we’ve reached your side of town yet! Remember, even if you don’t live in our service areas, you can still join the evolution of car care when you’re visiting any one of our zip codes. Brunching at the Pearl? Order gas! Having a business meeting downtown? Order gas! Visiting a friend in Southtown? You get the picture. We can’t wait to meet you!
                            </h3>
                        </div>
                    </div>

                    <div className="py-5">
                        <div className={`container d-flex flex-column-reverse flex-md-row mt-5 pb-5 `}>
                            <div className="col-md-5 col-lg-6 my-4 my-lg-0 text-center ">
                                {/* <GarageMap height={400} /> */}
                                <Image src={`https://firebasestorage.googleapis.com/v0/b/paleo-car-care.appspot.com/o/system-images%2Fterritories.gif?alt=media&token=93e50dfb-d6ae-4f9c-b1c7-11ab37e65ba4`} 
                                className="img-fluid rounded" 
                                alt='top-banner' 
                                loading='lazy'
                                width={750}
                                height={850}
                                 />
                            </div>
                            <div className="caption col-md-7 col-lg-6 d-flex  flex-column ">

                                <div className="col-md-10 text-center">
                                    <h2 className="heavy-bold dark-text fs-2">Zip Codes We Cover</h2>
                                </div>
                                <div className="d-flex flex-wrap justify-content-between col-8 mx-auto mt-0" >
                                    <div className='col-6 '>
                                        <ul className='zip-code-list '>
                                            {serviceZipCodes?.sort((a, b) => a?.zipCode > b?.zipCode ? 1 : -1)?.slice(0, serviceZipCodes?.length/2)?.map((i, index) => (
                                                <li key={index}>{i?.zipCode}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className='col-6'>
                                        <ul className='zip-code-list'>
                                            {serviceZipCodes?.sort((a, b) => a?.zipCode > b?.zipCode ? 1 : -1)?.slice(serviceZipCodes?.length/2)?.map((i, index) => (
                                                <li key={index}>{i?.zipCode}</li>
                                            ))}
                                        </ul>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <DownloadAppFooter/>
            </CommonStyle>
        </div>
    )
}

export default SupportedLocation